import { UseQueryOptions } from 'react-query';
import { AxiosResponse } from 'axios';
import { useCustomMutate, useCustomQuery } from '../../../../../hooks/query';
import {
  GET_COORDINATOR_RESULT_RELEASE_BY_INDEX_NO,
  POST_BULK_DOWNLOAD_COORDINATOR_RESULT_RELEASE,
  POST_COORDINATOR_RESULT_RELEASE_SEARCH_PARAM,
} from './keys';
import {
  getCoordinatorIndividualResultReleaseByIndexNo,
  postCoordinatorBulkUploadData,
  postCoordinatorSearchResultRelease,
} from '../api-services/api';
import { ServiceError } from '../../../../../hooks/error';
import {
  CandidatePsleResultReleaseSchema,
  CandidateResultReleaseSchema,
} from '../../../../../models/@candidate/CandidateResultReleaseSchema';
import {
  BulkDownloadCoordinatorResultReleaseResponse,
  CoordinatorResultReleaseResponse,
} from '../models';

/** to get coordinator candidate result release by search params
 * @returns CoordinatorResultReleaseResponse
 * */
export const usePostCoordinatorResultReleaseSearchParam = (
  successCallback: (res: AxiosResponse<CoordinatorResultReleaseResponse>) => void,
  failCallback: (res: any) => void
) =>
  useCustomMutate(
    POST_COORDINATOR_RESULT_RELEASE_SEARCH_PARAM,
    postCoordinatorSearchResultRelease,
    {
      onSuccess: (res) => successCallback(res),
      onError: (err) => failCallback(err),
    },
    false,
    false
  );

/** to get coordinator candidate result release by index no
 * @returns CandidateResultReleaseSchema
 * */
export const useGetCoordinatorResultReleaseByIndexNo = (
  indexNo: string,
  queryOptions?:
    | UseQueryOptions<CandidateResultReleaseSchema | CandidatePsleResultReleaseSchema, ServiceError>
    | undefined
) =>
  useCustomQuery<CandidateResultReleaseSchema | CandidatePsleResultReleaseSchema>(
    GET_COORDINATOR_RESULT_RELEASE_BY_INDEX_NO,
    () => getCoordinatorIndividualResultReleaseByIndexNo(indexNo).then((res) => res.data),
    queryOptions,
    false,
    true
  );

/** to post bulk download data
 * @returns CandidateResultReleaseSchema
 * */
export const usePostBulkDownloadCoordinatorResultRelease = (
  successCallback: (res: BulkDownloadCoordinatorResultReleaseResponse) => void,
  failCallback: (res: any) => void
) =>
  useCustomMutate(
    POST_BULK_DOWNLOAD_COORDINATOR_RESULT_RELEASE,
    postCoordinatorBulkUploadData,
    {
      onSuccess: (res) => successCallback(res.data),
      onError: (err) => failCallback(err),
    },
    false,
    false
  );
